'use strict';

angular.module('ecrd.queries')
    .controller('queriesMainController', ['$log', 'ShareCrfSDK', function($log, ShareCrfSDK) {
        var vm = this;

        vm.ready = false;
        vm.error = false;

        vm.$onInit = function() {
            ShareCrfSDK.users.getAvailableSites()
                .then(function(sites) {
                    vm.availableSites = sites;
                })
                .catch(function(error) {
                    vm.error = true;
                    $log.error(error, 'get available sites in queries main controller');
                });
        };
    }]);
